const ENTITY_NAME = "Isolation group";
const PAGE_TITLES = {
  create: `Create an isolation group`,
  list: `Manage isolation groups`,
  view: "View isolation group"
};
const ARCHIVE_TEXT = `Archived ${ENTITY_NAME.toLowerCase()}s cannot be used in configuration of new experiments. Existing experiments can continue to use the archived ${ENTITY_NAME.toLowerCase()}.`;
const ACTIVATE_TEXT = `This will make the selected ${ENTITY_NAME.toLowerCase()} active for use in feature experiments.`;
const reduxActionTypePrefix = `isolation-group-app-module`;
export {
  ACTIVATE_TEXT,
  ARCHIVE_TEXT,
  ENTITY_NAME,
  PAGE_TITLES,
  reduxActionTypePrefix
};
//# sourceMappingURL=module.constants.js.map
